import { render, staticRenderFns } from "./synthesize.vue?vue&type=template&id=fe3160ae&scoped=true&"
import script from "./synthesize.vue?vue&type=script&lang=js&"
export * from "./synthesize.vue?vue&type=script&lang=js&"
import style0 from "./synthesize.vue?vue&type=style&index=0&id=fe3160ae&prod&lang=less&scoped=true&media=print&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3160ae",
  null
  
)

export default component.exports